import { render, staticRenderFns } from "./password-create.vue?vue&type=template&id=fb3f65f2&"
import script from "./password-create.vue?vue&type=script&lang=js&"
export * from "./password-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports